import { useTranslation } from "react-i18next";
import PageHero from "@/components/layout/PageHero";
import { VisualSection, VisualBanner, VisualCta } from "@/components/layout/visualLayout";
import SectionIntro from "@/components/layout/SectionIntro";
import PremiumSteps from "@/components/layout/PremiumSteps";
import Reveal from "@/components/common/Reveal";
import HoverGlow from "@/components/motion/HoverGlow";

export default function Startups() {
  const { t } = useTranslation();
  const criteria = t("startups.criteria", { returnObjects: true });

  const steps = [1, 2, 3, 4, 5].map((n) => ({
    title: t(`startups.step${n}`),
    body: t(`startups.step${n}Body`),
  }));

  return (
    <div data-testid="page-startups">
      <PageHero
        eyebrow={t("startups.eyebrow")}
        title={t("startups.title")}
        subtitle={t("startups.lead")}
        testId="startups-hero"
      />

      <VisualSection testId="startups-process" divider>
        <SectionIntro eyebrow={t("startups.stepsEyebrow")} />
        <PremiumSteps steps={steps} testId="startups-steps" />
      </VisualSection>

      <VisualSection testId="startups-criteria" divider ambient="mission">
        <SectionIntro eyebrow={t("startups.criteriaEyebrow")} title={t("startups.criteriaTitle")} />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="startups-criteria">
          {Array.isArray(criteria) &&
            criteria.map((c, i) => (
              <Reveal key={i} delay={i * 0.04}>
                <HoverGlow className="h-full">
                  <div className="wit-card py-6 h-full group" data-testid={`startups-criterion-${i}`}>
                    <p className="wit-eyebrow text-warmGrey mb-2 normal-case tracking-widest">{c.k}</p>
                    <p className="wit-body text-ink">{c.v}</p>
                  </div>
                </HoverGlow>
              </Reveal>
            ))}
        </div>
      </VisualSection>

      <VisualBanner
        title={t("startups.trustTitle")}
        subtitle={t("startups.trustBody")}
        testId="startups-trust"
      />

      <VisualCta to="/submit-startup" label={t("startups.cta")} testId="startups-cta" />
    </div>
  );
}
